export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-cath-kidston-d972f7778feb3d8489bc909eca14874f.png";